import { BUILD_VERSION, BUILD_NOTE } from "../lib/version";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#050505] text-gray-500" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
        <div className="font-mono tracking-wider">
          © 2026 RED INK STUDIOS · ALL RIGHTS RESERVED
        </div>
        <div className="flex items-center gap-3 font-mono">
          <span
            className="px-2 py-0.5 rounded bg-white/5 border border-white/10 text-gray-400"
            data-testid="build-version-badge"
            title={BUILD_NOTE}
          >
            {BUILD_VERSION}
          </span>
        </div>
      </div>
    </footer>
  );
}
